import { buckets } from './buckets';
import { root, id } from './vod';

export const vod = {
  ...root,
  id,
  buckets,
};
